import { Select } from 'antd';
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import useInpFiles from '../../hooks/useInpFiles';
import useMetereological from '../../hooks/useMetereological';

const SelectMetereological = forwardRef(
	(
		{
			onSelect,
			emitObject,
			defaultValue = null,
			mode,
			otherSettings = {},
		}: {
			onSelect: Function;
			emitObject?: boolean;
			defaultValue?: any;
			mode: 'forecast' | 'historical' | 'all';
			otherSettings?: any;
		},
		ref,
	) => {
		const [selectedValue, setSelectedValue] = useState<any>(defaultValue);
		const { meterelogicals } = useMetereological();

		useImperativeHandle(ref, () => ({
			setValue: (value: any) => {
				setSelectedValue(value);
			},
		}));

 const filterMeterelogicals = (meterelogicals || [])
    .filter((m) => {
      const isNone =
        m.meterologicalId === null &&
        m.name === 'NONE (do not generate forecast)';

      // Include NONE in all modes except 'historical'
      if (isNone) {
        return mode !== 'historical';
      }

      switch (mode) {
        case 'forecast':
          return m.apply_forecast;
        case 'historical':
          return m.apply_historical;
        case 'all':
          return true;
        default:
          return true;
      }
    })
    .map((m) => ({
      value: emitObject ? JSON.stringify(m) : m.meterologicalId,
      label: m.name,
    }));

		return (
			<Select
				{...otherSettings}
				value={selectedValue}
				placeholder="Select an option"
				defaultValue={defaultValue}
				showSearch
				defaultActiveFirstOption={false}
				onChange={(val: string | null) => {
					// Allow null values (for NONE option) and non-empty string values
					if (val !== undefined) {
						setSelectedValue(val);
						if (emitObject) {
							// If val is null, pass null directly, otherwise parse the JSON
							onSelect(val === null ? null : JSON.parse(val || '{}'));
						} else {
							onSelect(val);
						}
					}
				}}
				style={{ width: '100%' }}
				options={filterMeterelogicals}
			/>
		);
	},
);

export default SelectMetereological;
